/* tslint:disable */
/* eslint-disable */
/**
 * Flawtrack Backend
 * Flawtrack ASM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InfringementEvent
 */
export interface InfringementEvent {
    /**
     * 
     * @type {number}
     * @memberof InfringementEvent
     */
    readonly id: number;
    /**
     * When this event occurred
     * @type {Date}
     * @memberof InfringementEvent
     */
    readonly eventDate: Date;
    /**
     * Description of the progress or action taken
     * @type {string}
     * @memberof InfringementEvent
     */
    description: string;
    /**
     * 
     * @type {Date}
     * @memberof InfringementEvent
     */
    readonly createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof InfringementEvent
     */
    readonly updatedAt: Date;
}

/**
 * Check if a given object implements the InfringementEvent interface.
 */
export function instanceOfInfringementEvent(value: object): value is InfringementEvent {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('eventDate' in value) || value['eventDate'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function InfringementEventFromJSON(json: any): InfringementEvent {
    return InfringementEventFromJSONTyped(json, false);
}

export function InfringementEventFromJSONTyped(json: any, ignoreDiscriminator: boolean): InfringementEvent {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'eventDate': (new Date(json['event_date'])),
        'description': json['description'],
        'createdAt': (new Date(json['created_at'])),
        'updatedAt': (new Date(json['updated_at'])),
    };
}

  export function InfringementEventToJSON(json: any): InfringementEvent {
      return InfringementEventToJSONTyped(json, false);
  }

  export function InfringementEventToJSONTyped(value?: Omit<InfringementEvent, 'id'|'event_date'|'created_at'|'updated_at'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'description': value['description'],
    };
}

